import type { StripeElementsOptions } from '@stripe/stripe-js';
import { usePaymentContext } from '../../../contexts/payment';
import { toAmountInCents } from '../utils';

const getStripeElementsOptions = (amountInCents: number) =>
  ({
    mode: 'payment',
    amount: amountInCents,
    currency: 'usd',
    paymentMethodTypes: ['card'],
    setupFutureUsage: 'off_session',
    captureMethod: 'manual',
    appearance: {
      variables: {
        borderRadius: '100px'
      }
    }
  }) satisfies StripeElementsOptions;

export const useDigitalWalletsElementsOptions = () => {
  const {
    state: {
      paymentSummary: {
        purchasePaymentBreakdown: { amountDue }
      }
    }
  } = usePaymentContext();

  return getStripeElementsOptions(toAmountInCents(amountDue));
};
